export const fieldStyling = {
  height: '2.33rem',
  padding: '15px',
  fontSize: '15px',
  borderRadius: '10px',
  color: '#000',
  fontFamily:
    '"Inter var", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
};
export const composableFieldStyling = {
  fontSize: '15px',
  borderRadius: '10px',
  color: '#000',
  fontFamily:
    '"Inter var", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left',
  position: 'relative',
  paddingLeft: '1px',
};

export const showStyling = {
  color: '#1E293B',
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily:
    '"Inter var", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '24px',
};
